import { render } from "./InvoiceEditorReservation.vue?vue&type=template&id=50bdf85c&scoped=true"
import script from "./InvoiceEditorReservation.vue?vue&type=script&lang=js"
export * from "./InvoiceEditorReservation.vue?vue&type=script&lang=js"

import "./InvoiceEditorReservation.vue?vue&type=style&index=0&id=50bdf85c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bdf85c"]])

export default __exports__